query CharityBankAccounts(
  $charityId: ID!
  $status: [CharityBankAccountStatusEnum]
  $hasFlaggedChecklistItems: Boolean
  $checklistIncomplete: Boolean
) {
  charityBankAccounts(
    charityId: $charityId
    status: $status
    hasFlaggedChecklistItems: $hasFlaggedChecklistItems
    checklistIncomplete: $checklistIncomplete
  ) {
    id
    status
    bankName
    bankCountry
    bankCurrency
    accountHolderName
    accountNumber
    iban
    abaRoutingNumber
    sortCode
    swiftCode
    accountNumberLast4
    notes
    submittedAt
    verifiedAt
    verificationNotes
    rejectionReason
    createdAt
    checklistHasFlaggedItems
    checklistIncomplete
    charity {
      id
      name
      charityHqCountry
    }
    createdByUser {
      id
      firstName
      surname
      email
    }
    submittedByUser {
      id
      firstName
      surname
      email
    }
    verifiedByUser {
      id
      firstName
      surname
      email
    }
    charityBankAccountProofs {
      id
      fileUrl
      documentType
      fileName
    }
    charityBankAccountChecklistItems {
      id
      itemKey
      status
      notes
      reviewedAt
      reviewedByUser {
        id
        firstName
        surname
      }
    }
    charityBankAccountVerificationCalls {
      id
      callDateTime
      callOutcome
      organizationName
      contactName
      contactRole
      identityConfirmationMethod
      telephoneNumberCalled
      phoneNumberSource
      emailAddressUsed
      emailSource
      redFlagsPresent
      redFlagsMitigationNotes
      bankName
      bankAddress
      accountHolderName
      accountHolderAddress
      accountNumber
      iban
      abaRoutingNumber
      sortCode
      swiftCode
      notes
      comments
      intermediaryBankDetails
      intermediaryBankName
      accountCurrency
      preCallChecklist
      duringCallChecklist
      completedByUser {
        id
        firstName
        surname
      }
    }
  }
}
